import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	checkboxRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	hint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	message: {
		color: THEME.colors.text.light,
		padding: THEME.spacing.md,
	},
	warning: {
		background: THEME.colors.pill.yellow.background,
		border: `1px solid ${THEME.colors.pill.yellow.border}`,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.sm,
		padding: THEME.spacing.sm,
	},
});
